<template>
  <ul class="flex gap-x-2 gap-y-4 wrap" :class="brandClasses?.list">
    <li v-for="{ label, thumbnail, url } of data" :key="label" class="w-22">
      <component :is="url ? BaseLink : 'div'" class="f-col items-center" :to="url || undefined">
        <base-picture
          v-if="thumbnail || benefitsAttributeImages"
          :alt="label"
          class="mb-4 mt-3 aspect-square h-16 w-16"
          :class="{ invisible: !thumbnail && !benefitsAttributeImages }"
          fit="contain"
          height="64"
          :src="thumbnail
            || `/img/benefits-attribute/${label?.toLowerCase().split(' ').join('-')}.svg`"
          width="64"
        />
        <p v-if="label" class="line-clamp-2 break-words text-center">
          {{ label }}
        </p>
      </component>
    </li>
  </ul>
</template>

<script setup lang="ts">
import type { ProductDetailContent } from '#types/product'
import { BaseLink } from '#components'

defineProps<{
  data: ProductDetailContent[]
}>()

const { benefitsAttributeImages } = useAppConfig().pages.pdp.accordions || {}
const { brandClasses } = useAppConfig().components.product.accordions.grid || {}
</script>
